import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useAtom } from "jotai";
import { useEffect, useRef, useState } from "react";
import { authClient } from "@/clients/authClient";
import { selectedPlaceIdAtom } from "@/lib/atoms/map.atoms";
import { useLoginModal } from "@/lib/hooks/useLoginModal";
import { useMapPlaces } from "@/lib/hooks/useMapPlaces";
import { trpc } from "@/router";
export function useKartaView() {
  const $ = _c(44);
  const {
    places: allPlaces,
    isFetching
  } = useMapPlaces();
  const [selectedPlaceId, setSelectedPlaceId] = useAtom(selectedPlaceIdAtom);
  const [accessFilter, setAccessFilter] = useState("alla");
  let t0;
  if ($[0] !== accessFilter || $[1] !== allPlaces) {
    let t1;
    if ($[3] !== accessFilter) {
      t1 = p => {
        if (accessFilter === "alla") {
          return true;
        }
        if (accessFilter === "kartlagda") {
          return p.hasVerifiedFeature;
        }
        if (accessFilter === "vantar") {
          return p.hasPendingFeature && !p.hasVerifiedFeature;
        }
        return !p.hasVerifiedFeature && !p.hasPendingFeature;
      };
      $[3] = accessFilter;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = allPlaces.filter(t1);
    $[0] = accessFilter;
    $[1] = allPlaces;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const places = t0;
  const {
    data: session
  } = authClient.useSession();
  const loginModal = useLoginModal();
  const navigate = useNavigate();
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      from: "/_app/karta/"
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    plats,
    bidra
  } = useSearch(t1);
  const flyToRef = useRef(null);
  let t2;
  if ($[6] !== loginModal || $[7] !== navigate || $[8] !== session?.user) {
    t2 = (placeId, placeName) => {
      if (!session?.user) {
        loginModal.onOpen();
        return;
      }
      if (placeId && placeName) {
        navigate({
          to: "/bidra",
          search: {
            plats: placeId,
            platsNamn: placeName
          }
        });
      } else {
        navigate({
          to: "/bidra"
        });
      }
    };
    $[6] = loginModal;
    $[7] = navigate;
    $[8] = session?.user;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const openReport = t2;
  let t3;
  if ($[10] !== plats || $[11] !== selectedPlaceId || $[12] !== setSelectedPlaceId) {
    t3 = () => {
      if (plats && plats !== selectedPlaceId) {
        setSelectedPlaceId(plats);
      }
    };
    $[10] = plats;
    $[11] = selectedPlaceId;
    $[12] = setSelectedPlaceId;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== plats) {
    t4 = [plats];
    $[14] = plats;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  useEffect(t3, t4);
  const bidraHandled = useRef(false);
  let t5;
  if ($[16] !== bidra || $[17] !== openReport) {
    t5 = () => {
      if (bidra && !bidraHandled.current) {
        bidraHandled.current = true;
        openReport();
      }
    };
    $[16] = bidra;
    $[17] = openReport;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== bidra) {
    t6 = [bidra];
    $[19] = bidra;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  useEffect(t5, t6);
  let t7;
  if ($[21] !== selectedPlaceId) {
    t7 = trpc.places.byId.queryOptions({
      id: selectedPlaceId
    });
    $[21] = selectedPlaceId;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const t8 = !!selectedPlaceId;
  let t9;
  if ($[23] !== t7 || $[24] !== t8) {
    t9 = {
      ...t7,
      enabled: t8
    };
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const {
    data: selectedPlaceData
  } = useQuery(t9);
  const hasFlewRef = useRef(null);
  let t10;
  let t11;
  if ($[26] !== selectedPlaceData) {
    t10 = () => {
      if (selectedPlaceData && flyToRef.current && hasFlewRef.current !== selectedPlaceData.id) {
        hasFlewRef.current = selectedPlaceData.id;
        flyToRef.current(selectedPlaceData.location.longitude, selectedPlaceData.location.latitude);
      }
    };
    t11 = [selectedPlaceData];
    $[26] = selectedPlaceData;
    $[27] = t10;
    $[28] = t11;
  } else {
    t10 = $[27];
    t11 = $[28];
  }
  useEffect(t10, t11);
  let t12;
  if ($[29] !== navigate || $[30] !== setSelectedPlaceId) {
    t12 = id => {
      setSelectedPlaceId(id);
      navigate({
        to: "/karta",
        search: {
          plats: id
        },
        replace: true
      });
    };
    $[29] = navigate;
    $[30] = setSelectedPlaceId;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  const selectPlace = t12;
  let t13;
  if ($[32] !== navigate || $[33] !== setSelectedPlaceId) {
    t13 = () => {
      setSelectedPlaceId(null);
      hasFlewRef.current = null;
      navigate({
        to: "/karta",
        search: {},
        replace: true
      });
    };
    $[32] = navigate;
    $[33] = setSelectedPlaceId;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  const clearSelection = t13;
  let t14;
  if ($[35] !== accessFilter || $[36] !== allPlaces || $[37] !== clearSelection || $[38] !== isFetching || $[39] !== openReport || $[40] !== places || $[41] !== selectPlace || $[42] !== selectedPlaceId) {
    t14 = {
      places,
      allPlaces,
      isFetching,
      selectedPlaceId,
      accessFilter,
      setAccessFilter,
      flyToRef,
      selectPlace,
      clearSelection,
      openReport
    };
    $[35] = accessFilter;
    $[36] = allPlaces;
    $[37] = clearSelection;
    $[38] = isFetching;
    $[39] = openReport;
    $[40] = places;
    $[41] = selectPlace;
    $[42] = selectedPlaceId;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  return t14;
}